import React, { useEffect, useState } from 'react';
import { Button } from '@/components/Button/Button';
import { PopupModal } from 'react-calendly';

const CalendlyEmbeded: React.FC<any> = ({
  sx,
  children,
  variant = 'contained',
  color = 'secondary',
  icon,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [rootElement, setRootElement] = useState(null);

  useEffect(() => {
    setRootElement(document.getElementById('__next'));
  }, []);

  return (
    <div>
      <Button
        sx={sx}
        startIcon={icon}
        color={color}
        variant={variant}
        onClick={() => setIsOpen(true)}
      >
        {children}
      </Button>
      <PopupModal
        url="https://calendly.com/ashley-yesayan/book-a-demo"
        onModalClose={() => setIsOpen(false)}
        open={isOpen}
        rootElement={rootElement}
      />
    </div>
  );
};

export default CalendlyEmbeded;
